<div class="generic-modal-root">

  <ngx-loading [show]="working"></ngx-loading>

  <div>
    <div class="row">
      <div class="col-lg-5">
        <div class="row">
          <div class="col-lg-4 col-form-label">
            Frame:
          </div>
          <div class="col-lg-8">
            <select class="form-control m-input" [(ngModel)]="selectedFrame">
              <option *ngFor="let frame of frames" [ngValue]="frame">
                {{frame.name}}
              </option>
            </select>
          </div>
        </div>

        <div class="row" *ngIf="selectedFrame?.image1X">
          <div class="col-lg-4 col-form-label">
            Image 1:
          </div>
          <div class="col-lg-8">
            <app-file-upload multiple="false" (filesSet)="setPng1($event[0]);" text="Png 1" id="png1File"
              accept=".png"></app-file-upload> {{img1Name}}
            <div class="text-danger position-absolute" *ngIf="img1Error">
              Please upload a .png file.
            </div>
          </div>
        </div>

        <div class="row" *ngIf="selectedFrame?.image2X">
          <div class="col-lg-4 col-form-label">
            Image 2:
          </div>
          <div class="col-lg-8">
            <app-file-upload multiple="false" (filesSet)="setPng2($event[0]);" text="Png 2" id="png2File"
              accept=".png"></app-file-upload> {{img2Name}}
            <div class="text-danger position-absolute" *ngIf="img2Error">
              Please upload a .png file.
            </div>
          </div>
        </div>

        <div class="row" *ngIf="hasColor1">
          <div class="col-lg-4 col-form-label">
            Color 1:
          </div>
          <div class="col-lg-8">
            <input [cpAlphaChannel]="'disabled'" maxlength="7" class="form-control m-input" placeholder={{color1}}
            (colorPickerChange)="color1 = $event" [colorPicker]="color1" [cpDisableInput]="true" [style.background]="color1">
          </div>
        </div>

        <div class="row" *ngIf="hasColor2">
          <div class="col-lg-4 col-form-label">
            Color 2:
          </div>
          <div class="col-lg-8">
            <input maxlength="7" class="form-control m-input" placeholder={{color2}}
            (colorPickerChange)="color2 = $event" [cpDisableInput]="true" [cpAlphaChannel]="'disabled'" [colorPicker]="color2" [style.background]="color2">
          </div>
        </div>

        <div class="row" *ngIf="selectedFrame?.labelFont">
          <div class="col-lg-4 col-form-label">
            Font color:
          </div>
          <div class="col-lg-8">
            <input pattern="#[0-9a-fA-F]*" maxlength="7" class="form-control m-input" placeholder={{fontColor}}
              [(ngModel)]="fontColor" [cpAlphaChannel]="'disabled'" [cpDisableInput]="true" [(colorPicker)]="fontColor" [style.background]="fontColor">
          </div>
        </div>

        <div class="row" *ngIf="selectedFrame?.labelFont">
          <div class="col-lg-4 col-form-label">
            Text:
          </div>
          <div class="col-lg-8">
            <input class="form-control m-input" maxlength="40" placeholder={{text}} [(ngModel)]="text">
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <div style="background:transparent; height: 545px; width:436px; position: relative; box-shadow: 0 3px 15px 6px rgba(120, 99, 225, 0.22);">
            <img style="position: absolute; z-index: 1; top: 50%; transform: translate(0, -50%);" alt="" src="assets/app/media/img/misc/selfie_sample.jpeg">
            <img style="position: absolute; z-index: 2;" #mainImg>
        </div>
      </div>
    </div>
  </div>

  <div style="height: 45px;">
    <span *ngIf="colorError" style="color: red; margin:10px; float:left">One or more colors contain an error</span>
    <button (click)="close()" class="btn btn-success" style="margin:10px; float:right">Cancel</button>
    <button (click)="saveAndClose()" class="btn btn-success" style="margin-top:10px; float:right">Save filter</button>
  </div>
</div>